import React, { Fragment } from 'react'
import {
    List, Datagrid, Filter, ShowButton, UrlField, Button, TextInput, TextField, EditButton, BulkDeleteButton, FunctionField, DeleteButton, useRecordContext, Link
} from 'react-admin'
import { InfluencerStatusSelectInput } from '../../UI/Input/SelectInput'
import DownloadIcon from '@material-ui/icons/GetApp';
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'

const ListFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        {/* <InfluencerStatusSelectInput label="Status" source="status" alwaysOn /> */}
    </Filter>
)
const ListActionButtons = ({ ...props }) => {
    return (<>
        <BulkDeleteButton {...props} undoable={false}
            confirmTitle="Delete File Record"
            confirmContent={"Are you sure you want to delete this record?"} />
    </>)
}
const ProfileidFiled = (props) => {
    const record = useRecordContext();
    return (
        <TextField {...props} component={Link} to={`/user?filter={"q":"${record.profile_id}"}`} onClick={(event) => event.stopPropagation()} />
    )
}


const NewInfluencerList = ({ ...props }) => {

    return (
        <List {...props} title="Influencer" bulkActionButtons={<ListActionButtons />} filters={<ListFilter />} sort={{ field: 'title', order: 'ASC' }}>

            <Datagrid >

                <ProfileidFiled source="profile_id" label="Profile Id" />
                <TextField source='name' label="name" />
                <FunctionField source="content_url" label="Link" render={record => {
                    return (<Button target="_blank" style={{ color: 'green', border: '1px solid' }} href={record.content_url} label="Link" size="small"></Button>)

                }} />

                <TextField source="title" label="Title" />
                <TextField source="description" label="Description" />
                <TextField source='created_at' label="Created At" />


            </Datagrid>

        </List>
    )
}


export default NewInfluencerList